import { ReactNode } from 'react';

import './ModalFooter.scss';

interface ModalFooterProps {
  readonly children: ReactNode;
}

function ModalFooter({ children }: ModalFooterProps) {
  return <div className="stratus--selection-modal-footer">{children}</div>;
}

export default ModalFooter;
